export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ01.13e884ff.mp3";